import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { ListItem, ListItemText } from "@material-ui/core";
import useStyles from "./styles";

const LineItem = ({ id, line_item: { item_id, quantity, name, item_variation_name, modifiers, notes } }) => {
  const classes = useStyles();
  return (
    <>
      <ListItem className={classes.paddingBottom0}>
        <ListItemText primaryTypographyProps={{ className: classes.bold }} primary={`${quantity} x ${name}`} />
      </ListItem>
      <ul className={classes.nobullets}>
        <li className={classes.margin1}>{item_variation_name}</li>
        {modifiers.map(({ modifier_option_id, name }) => (
          <li key={`${id}-${item_id}-${modifier_option_id}`} className={classes.margin1}>
            {name}
          </li>
        ))}
        {notes ? <li className={clsx(classes.margin1, classes.italic)}>{notes}</li> : null}
      </ul>
    </>
  );
};

LineItem.propTypes = {
  id: PropTypes.string.isRequired,
  line_item: PropTypes.object.isRequired
};

export default LineItem;
